// extracted by mini-css-extract-plugin
export default {"title":"TabTre_title__X-nPu","textFieldDisabled":"TabTre_textFieldDisabled__cJDxG"};